import router from '@/router'
import { DateTime } from 'luxon'
import lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'
import useFormatDate from '@/composables/useFormatDate'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import bulkFileApi from '@/services/bulkFile'
import i18n from '@/i18n/i18n'

const checkRequestValidation = () => {
  const formStore = useFormStore()
  const { departmentCode, serviceCode, sequenceNumber, serviceYear, fileModuleId } =
    formStore.form.values

  const isFile = departmentCode && serviceCode && sequenceNumber && serviceYear && fileModuleId

  return isFile || formStore.form.values.personUnifiedNumber
}

const fillData = (obj) => {
  const formStore = useFormStore()

  formStore.form.setValues({
    personUnifiedNumber: obj.unifiedNumber,
    englishName: obj.personEnglishName,
    arabicName: obj.personArabicName
  })

  if (obj.departmentCode) {
    formStore.form.setValues({
      departmentCode: obj.departmentCode,
      serviceCode: obj.serviceCode,
      serviceYear: obj.serviceYear,
      sequenceNumber: obj.sequenceNumber
    })
  }
}

const CheckFines = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()

  const serviceTransId = router.currentRoute.value.params.serviceId

  if (!globalStore.startedService.serviceConfig.enableFinesOnPermitLeaving) {
    formStore.extraMap = {
      ...formStore.extraMap,
      finesWarningMessage: '',
      showFinesWarningMessage: false
    }
  }
  if (!checkRequestValidation()) {
    return
  }

  try {
    const query = {
      sponsorUnifiedNumber: null,
      sponsorTypeId: null,
      sponsorImmigrationId: null,
      personUnifiedNumber: formStore.form.values.personUnifiedNumber,
      fileDepartmentCode: formStore.form.values.departmentCode,
      fileYear: formStore.form.values.serviceYear,
      fileTypeCode: formStore.form.values.serviceCode,
      fileSequenceNumber: formStore.form.values.sequenceNumber,
      serviceTransId,
      fileModuleId: formStore.form.values.fileModuleId
    }
    const res = await bulkFileApi.violatedFiles(query)

    formStore.extraMap.finesWarningMessage = ''
    formStore.extraMap.showFinesWarningMessage = false
    if (res && res.length > 0) {
      let files = ''
      formStore.extraMap.showchangeStatusMessage = false
      formStore.extraMap.showFinesMessage = false

      res.map((value) => {
        files = [
          value.departmentCode,
          value.serviceYear,
          value.serviceCode,
          value.sequenceNumber
        ].join(' , ')

        if (value.newVisaSequenceNumber) {
          formStore.extraMap.showchangeStatusMessage = true
          formStore.extraMap.changeStatusMessage = i18n.global.t('changeStatusMessage')
        }

        if (value.sequenceNumber) {
          if (globalStore.startedService.serviceConfig.multipleRequest) {
            formStore.extraMap = {
              ...formStore.extraMap,
              showFinesWarningMessage: true,
              finesWarningMessage: [
                i18n.global.t('existViolatedFiles1'),
                ':',
                files,
                i18n.global.t('existViolatedFiles2')
              ].join(' ')
            }
          } else {
            formStore.extraMap = {
              ...formStore.extraMap,
              finesWarningMessage: [
                i18n.global.t('existViolatedFilesWithAutoReq1'),
                ':',
                files,
                i18n.global.t('existViolatedFilesWithAutoReq2')
              ].join(' ')
            }
          }
        }
      })
      fillData(res[0])
    }
  } catch (error) {
    console.error('CheckFines error: ', error)
  }
}
const prepareResiRequest = async (body) => {
  try {
    const {
      ServiceTransactions,
      IssueGreenResidencyForSkilledPerson,
      IssueResidenceAndIdentityGreenResidencyForSkilledPerson
    } = lookups.ServiceTransactions
    const formStore = useFormStore()
    const serviceTransactionId = router.currentRoute.value.params.serviceId
    if (
      ![ServiceTransactions, IssueGreenResidencyForSkilledPerson].includes(serviceTransactionId)
    ) {
      return
    }
    const {
      personUnifiedNumber,
      resiVisaDepartmentCode,
      resiVisaYear,
      resiVisaServiceCode,
      resiVisaSequenceNumber
    } = formStore?.draft?.request || {}
    if (
      personUnifiedNumber &&
      resiVisaDepartmentCode &&
      resiVisaYear &&
      resiVisaServiceCode &&
      resiVisaSequenceNumber
    ) {
      const childEstablishmentId = router.currentRoute.value?.params?.childEstablishmentId
      const personImmigrationFileInput = {
        unifiedNumber: formStore.draft.request.personUnifiedNumber,
        fileDepartmentCode: formStore.draft.request.resiVisaDepartmentCode,
        fileYear: formStore.draft.request.resiVisaYear,
        fileTypeCode: formStore.draft.request.resiVisaServiceCode,
        fileSequance: formStore.draft.request.resiVisaSequenceNumber,
        serviceTransactionId,
        childEstablishmentId
      }
      const params = {
        serviceTransId: serviceTransactionId,
        establishmentId: childEstablishmentId
      }
      const res = await bulkFileApi.prepareResiForEstab(personImmigrationFileInput, params)

      if (client_config.enablePreparingPersonImmigrationFileApi) {
        formStore.draft.request = {
          ...formStore.draft.request,
          ...result.data.residencyRequest,
          manageFields: {}
        }
      } else {
        formStore.draft.request = result
        formStore.draft.request.manageFields = {}
      }

      // this code because the localHomePhone is disabled and should has uae code only
      const { localHomePhone } = formStore?.draft?.request || {}

      if ((localHomePhone || '').length > 5 && localHomePhone.substring(0, 5) != '00971') {
        formStore.draft.request.localHomePhone = undefined
      }
      formStore.draft = {
        ...formStore.draft,
        withException: router.currentRoute.value.params.withException === 'true' ? true : false,
        applicantId: formStore.draft.request.applicantId,
        request: {
          ...formStore.draft.request,
          establishmentId: router.currentRoute.value.params.childEstablishmentId
        }
      }

      if (formStore?.draft?.request?.professionId) {
        if (
          [
            IssueResidenceAndIdentityGreenResidencyForSkilledPerson,
            IssueGreenResidencyForSkilledPerson
          ].includes(serviceTransactionId)
        ) {
          formStore.draft.request.manageFields.isProfessionIdDisabled = true
        }
      } else {
        if (formStore.draft.request.manageFields) {
          formStore.draft.request.manageFields.isProfessionIdDisabled = false
        }
      }

      if (formStore.draft.request.faithId) {
        formStore.draft.request.isFaithExistOnUDB = true
      }

      return res
    }
  } catch (error) {
    formStore.draft.request = {}
    formStore.extraMap.showFinesWarningMessage = false
    console.error('prepareResiRequest error: ', error)
  }
}
const checkViolatedFiles = (source) => {
  const formStore = useFormStore()
  let requestOptObj = {}
  switch (source) {
    /* Person Resi File Number*/
    case 2:
      requestOptObj = {
        fileDepartmentCode: formStore?.draft?.request?.resiDepartmentCode,
        fileYear: formStore?.draft?.request?.resiYear,
        fileTypeCode: formStore?.draft?.request?.resiServiceCode,
        fileSequenceNumber: formStore?.draft?.request?.resiSequenceNumber
      }
      break
    case 3:
      requestOptObj = {
        fileDepartmentCode: formStore?.draft?.request?.resiVisaDepartmentCode,
        fileYear: formStore?.draft?.request?.resiVisaYear,
        fileTypeCode: formStore?.draft?.request?.resiVisaServiceCode,
        fileSequenceNumber: formStore?.draft?.request?.resiVisaSequenceNumber
      }
      break
    default:
      break
  }
  return requestOptObj
}

export default function (actionName, actionParams) {
  switch (actionName) {
    case 'checkFines':
      CheckFines()
      break

    default:
      break
  }
}
